<dx-popup
    title="Select Dumpsters"
    [width]="500"
    [height]="250"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-tag-box
        [(value)]="selectedIds"
        [items]="dumpsters"
        valueExpr="id"
        displayExpr="size"
        [showSelectionControls]="true"
        [showDropDownButton]="true"
    ></dx-tag-box>
</dx-popup>
